import { CMSGraphQLClient, gql } from '@nubank/www-latam-commons/utils/cms/CMSGraphQLClient';

export default async function getPageContent({ locale, preview, cache }) {
  const { data: { messages } } = await CMSGraphQLClient({ preview }).query({
    cache,
    query: gql`
      query($locale: SiteLocale) {
        businessAccountPage(locale: $locale) {
          headSeoBreadcrumbTitle
          headSeo {
            title
            description
            image {
              url
            }
          }
          heroTitle
          heroSubtitle
          cardsArea {
            ... on BusinessAccountPageCardSimpleRecord {
              id
              title
              description
              ctaText
              ctaLink
              componentName
            }
            ... on BusinessAccountPageCardAdvantageRecord {
              id
              title
              advantage {
                id
                title
              }
              componentName
            }
            ... on BusinessAccountPageCardBannerRecord {
              id
              componentName
            }
          }
        }
      }
    `,
    variables: {
      locale,
    },
  });

  return {
    businessAccountPage: messages.businessAccountPage,
  };
}
